module.exports = __webpack_public_path__ + "static/media/palletimage_ptplusadmin.f5e57bc0.png";